import {Component, Input, OnInit} from '@angular/core';
import {CompogeniusNaviTypeEnum} from "../../../../services/client/navigation-service/compogenius-navi-type.enum";
import {CompogeniusNaviObjectModel} from "../../../../services/client/navigation-service/compogenius-navi-object.model";
import {
  RoutesNavigationClientService
} from "../../../../services/client/navigation-service/routes-navigation-client.service";
import {NavigationExtras} from "@angular/router";
import { NgStyle } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'cp-navigation-link',
    templateUrl: './navigation-link.component.html',
    styleUrls: ['./navigation-link.component.scss'],
    imports: [NgStyle, TranslateModule]
})
export class NavigationLinkComponent implements OnInit {
  CompogeniusNaviTypeEnum = CompogeniusNaviTypeEnum;

  @Input()
  public routeType: CompogeniusNaviTypeEnum = CompogeniusNaviTypeEnum.HOME_PAGE;
  @Input()
  public routeId: string;
  @Input()
  public routeOldId: number;
  @Input()
  public onlyTrack: boolean = false;
  @Input()
  public navigationExtras: NavigationExtras;
  @Input()
  public isSuperClass: boolean = false;
  @Input()
  customStyle: { [klass: string]: any; } | null = null;
  @Input()
  customText: string;
  @Input()
  disabled: boolean;

  constructor(
    private routesNavigationClientService: RoutesNavigationClientService
  ) {
  }

  ngOnInit(): void {
  }

  onNavigate(): void {
    if (this.disabled) {
      return;
    }

    const command = this.routesNavigationClientService.getCommand(this.routeType);
    const model = new CompogeniusNaviObjectModel(command, this.routeId, this.routeOldId,null, this.routeType);

    if (this.onlyTrack) {
      this.routesNavigationClientService.track(model);
    } else {
      this.routesNavigationClientService.navTo(model, this.navigationExtras);
    }
  }

}
